import React, { useEffect, useState } from 'react';
import { GlobalNav, setGlobalNavUri } from '@snsw/react-global-nav';
import { ComponentLoader } from '@snsw/react-component-library';
import { GlobalNavLinks } from './GlobalNavLinks';
import { GlobalNavConfig } from './GlobalNavConfigs';
import { useApplicationConfig, useApplicationContext } from '../../store';

export const GlobalNavComponent = (props: { children: any; }) => {
    const config = useApplicationConfig();
    const globalNavConfig:GlobalNavConfig = config.appConfig.globalNavConfig;
    const { globalState } = useApplicationContext();
    const [ready, setReady] = useState(false);

    useEffect( () => {
        setGlobalNavUri(
            globalNavConfig.globalNavUrl,
            { 'x-api-key': globalNavConfig.globalNavUrlApiKey },
        );
        setReady(true);
    }, [globalNavConfig, globalState]);
    return ready ?
        <GlobalNav
            accountNavLinks={ <GlobalNavLinks appConfig={ globalNavConfig } /> }
            translation={ false }
        >
            {props.children}
        </GlobalNav> :
        <>
            <ComponentLoader
                active={ !ready }
                fullpage
                label='One moment, please...'
            />
        </>;
};
